import { render, staticRenderFns } from "./UserGraderAktif.vue?vue&type=template&id=33d5e5f1&"
import script from "./UserGraderAktif.vue?vue&type=script&lang=js&"
export * from "./UserGraderAktif.vue?vue&type=script&lang=js&"
import style0 from "./UserGraderAktif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports